import React from 'react';
import Form from './Form';
import {ControlledFormProps, FormState} from '../../@types/components/Form';
import Translate from '../Translate/Translate';
import {connect} from 'react-redux';
import {IReduxStoreState} from '../../@interfaces';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

const Alert = connect((state: IReduxStoreState) => ({
    locale: state.locale.locale
}))(function ({formName}: { formName: string }) {
    return <div className="alert alert-danger">
        <Translate message="Forms.errors.form_not_found" replace={{form: formName}}/>
    </div>;
});

export default abstract class ControlledForm<
        Model extends IEmptyModel = IEmptyModel,
        Props extends ControlledFormProps<Model> = ControlledFormProps<Model>,
        State extends FormState = FormState
> extends Form<Model, Props, State> {
    static defaultProps = {};

    protected get config() {
        return (this.service.getFormConfig(this.props.formName ?? '') ?? {}) as NonNullable<Props['config']>;
    }

    render(): JSX.Element {
        if (!Object.keys(this.config).length) {
            return <Alert formName={this.props.formName ?? ''}/>;
        }

        return super.render();
    }
}
